import { cn } from "@newxsystems/shared";
import { getComponent } from "../../../../client";
import type { IAbyssMediaProps } from "./AbyssMedia.props";

const ratios = {
  "1:1": "aspect-square",
  "4:3": "aspect-4/3",
  "3:2": "aspect-3/2",
  "16:9": "aspect-video",
  "21:9": "aspect-21/9",
  "3:4": "aspect-3/4",
  "2:3": "aspect-2/3",
} as const;

export const AbyssMedia = ({
  aspectRatio,
  className,
  frameClassName,
  imageClassName,
  media,
  priority,
  sizes,
}: IAbyssMediaProps) => {
  const Image = getComponent("Image");
  return (
    <figure className={cn("relative", className)}>
      <div
        className={cn(
          "relative overflow-hidden bg-surface-200",
          aspectRatio && ratios[aspectRatio],
          !media.caption && "h-full",
          frameClassName,
        )}
      >
        <Image
          alt={media.alternateText}
          className="h-full w-full"
          height={media.height || undefined}
          imageClassName={cn(
            "h-full w-full",
            aspectRatio ? "object-cover" : "object-contain",
            imageClassName,
          )}
          priority={priority}
          sizes={sizes || media.sizes || undefined}
          src={media.defaultSrc}
          srcSet={media.srcSet || undefined}
          width={media.width || undefined}
        />
      </div>
      {media.caption ? (
        <figcaption className="mt-3 max-w-[65ch] font-abyss-mono text-xs leading-[1.5] text-fog">
          {media.caption}
        </figcaption>
      ) : null}
    </figure>
  );
};

AbyssMedia.displayName = "Content::AbyssMedia";
